export default __webpack_public_path__ + "static/media/undo.2f003495.svg";